import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import MyDevice from '../images/my-device';
import Button from "react-bootstrap/esm/Button";
import Oval from '../images/Oval.svg';

function device() {

    return (
        <div className="App"
            style={{
                width: '100%',
                // height: '753px',
                backgroundColor: '#F9F9F9',
                // marginBottom: '40px',
                textAlign: 'center'
            }}>

            <div style={{
                fontSize: '11px', marginLeft: '20px',
                marginRight: '20px',
                paddingTop: '10px'
            }}>
                <div style={{
                    fontSize: '12px',
                    fontWeight: '700',
                    color: '#475666'
                }}>
                    <img src={Oval} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />   MY DEVICE
                </div>
            </div>
            <div style={{
                marginTop: '10px'
            }}>
                <Row>
                    <Col>
                        <div >

                            <img src={MyDevice} style={{ width: '116px', height: '208px' }} alt="" />
                        </div>
                    </Col>
                    <Col>
                        <div style={{
                            textAlign: 'left',
                            font: 'Sintony',
                            fontWeight: '400',
                            fontSize: '11px',
                            lineHeight: '15px',
                            color: '#545454',
                            marginTop: '12px',
                            marginLeft: '10px'
                        }}>
                            <Row>  <div>

                                <div style={{
                                    textAlign: 'left',
                                    font: 'Sintony',
                                    fontWeight: 'bold',
                                    fontSize: '11px',
                                    lineHeight: '15px',
                                    color: '#545454'

                                }}>ITEM:</div>
                                <div>  IQOS 3 DUO KIT
                                    BLACK</div>
                            </div></Row>
                            <Row>  <div style={{
                                textAlign: 'left',
                                font: 'Sintony',

                                fontSize: '11px',
                                lineHeight: '15px',
                                color: '#545454',
                                marginTop: '12px',
                                marginBottom: '12px'

                            }}>

                                <div style={{
                                    textAlign: 'left',
                                    font: 'Sintony',
                                    fontWeight: 'bold',
                                    fontSize: '11px',
                                    lineHeight: '15px',
                                    color: '#545454'


                                }}> PURCHASED:</div>
                                <div>09/01/20</div>
                            </div></Row>
                            <Row>  <div >

                                <div style={{
                                    textAlign: 'left',
                                    font: 'Sintony',
                                    fontWeight: 'bold',
                                    fontSize: '11px',
                                    lineHeight: '15px',
                                    color: '#545454'

                                }}>PURCHASE LOCATION:</div>
                                <div>The Tobacco Shop</div>
                            </div></Row>
                        </div>
                    </Col>

                </Row>
            </div>
            <div style={{
                marginTop: '10px'
            }}>
                <Button variant="outline-secondary" size="lg" type="submit" style={{
                    height: '43px',
                    width: '144px',
                    fontSize: '12px',
                    borderRadius: '0'

                }} >
                    CHANGE DEVICE
                </Button>
            </div>
        </div >

    );
}

export default device; 